import React from "react";
import { Layout } from "antd";

export default function EmptyLayout({ children }) {
  return <Layout>{children}</Layout>;
}
